export enum TargetAudience {
	NON_MEMBERS = "NON_MEMBERS",
	MEMBERS = "MEMBERS",
	FORMER_MEMBERS = "FORMER_MEMBERS",
}

export interface NotificationCMS {
	_id: string;
	title: string;
	content: string;
	level: string;
	link?: {
		title: string;
		url: string;
	};
	isEmailNotification: boolean;
	targetAudience: TargetAudience;
	scheduledAt: string;
	expiresAt?: string;
}
